import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactComponent as WarnIcon } from '../images/alertsign.svg';
import { ReactComponent as ErrorIcon } from '../images/circlecl.svg';
import { ReactComponent as CheckIcon } from '../images/circleChek.svg';
import { ReactComponent as InfoIcon } from '../images/circleInf.svg';
import { ReactComponent as QuestIcon } from '../images/circleQuest1.svg';
import { ReactComponent as CloseIcon } from '../images/closeCross.svg';

const CloseButton = ({ closeToast }) => <CloseIcon onClick={closeToast} />;

export const showErrorToast = message => {
  const toastOptions = {
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: <ErrorIcon />,
    closeButton: <CloseButton />,
    className: 'toast-error-custom', // Клас для контейнера
    progressClassName: 'toast-progress-custom'

  };

  toast.error(message, toastOptions);
};

export const showSuccessToast = message => {
  const toastOptions = {
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: <CheckIcon />,
    closeButton: <CloseButton />,
    className: 'toast-success-custom', // Клас для контейнера
    progressClassName: 'toast-progress-custom'
  };

  toast.success(message, toastOptions);
};
export const showWarningToast = message => {
  const toastOptions = {
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: <WarnIcon />,
    closeButton: <CloseButton />,
    className: 'toast-warning-custom', // Клас для варнінгу
    progressClassName: 'toast-progress-custom' // Клас для прогрес-бару
  };

  toast.warn(message, toastOptions); // Використовуємо метод `warn` для варнінгу
};

export const showInfoToast = message => {
  const toastOptions = {
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: <InfoIcon />, // Іконка для інформаційного тосту
    closeButton: <CloseButton />,// Кастомна кнопка закриття
    className: 'toast-info-custom', // Клас для інформаційного тосту
    progressClassName: 'toast-progress-custom'
  };

  toast.info(message, toastOptions); // Використовуємо метод `info` для інформаційного тосту
};

export const showQuestionToast = (message) => {
  const toastOptions = {
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: <QuestIcon />,
    closeButton: <CloseButton />,
    className: 'toast-question-custom',
    progressClassName: 'toast-progress-custom'
  };

  toast.info(message, toastOptions);
}